// Regional builder landing pages data
// Targets "home builders [region]" and "builders near me [region]" searches

export const regionalData = {
  "northern-adelaide": {
    slug: "northern-adelaide",
    name: "Northern Adelaide",
    metaTitle: "Home Builders Northern Adelaide | Local Builders | BuildPilot",
    metaDescription: "Find trusted home builders in Northern Adelaide. Covering Gawler, Salisbury, Elizabeth, Munno Para, Angle Vale, Two Wells and surrounding suburbs.",
    heroTitle: "Home Builders in Northern Adelaide",
    heroSubtitle: "Local builders who know the north",
    intro: "Northern Adelaide is one of Adelaide's fastest-growing regions with affordable land and strong infrastructure investment. Finding a builder who knows the area means better advice on estates, soil conditions, and local council requirements.",
    
    coverage: [
      "Gawler & Gawler East",
      "Salisbury & Salisbury North",
      "Elizabeth & Elizabeth Vale",
      "Munno Para & Munno Para West",
      "Angle Vale",
      "Two Wells",
      "Craigmore & Blakeview",
      "Andrews Farm & Smithfield",
      "Paralowie & Burton",
      "Virginia & Buckland Park"
    ],
    
    popularEstates: [
      { name: "Riverlea", location: "Buckland Park", link: "/estates/riverlea" },
      { name: "Liberty Two Wells", location: "Two Wells", link: "/estates/liberty-two-wells" },
      { name: "Playford Alive", location: "Munno Para", link: "/estates/playford-alive" },
      { name: "Angle Vale estates", location: "Angle Vale", link: "/estates/angle-vale-estate" }
    ],
    
    whyBuildHere: [
      "Affordable land prices compared to southern and eastern Adelaide",
      "Strong infrastructure investment including Northern Expressway",
      "Growing employment hubs reducing commute dependency",
      "Range of lot sizes from compact to larger blocks",
      "Multiple display villages to visit in one trip",
      "Family-friendly suburbs with new schools and facilities"
    ],
    
    considerations: [
      "Soil conditions vary. Some areas have reactive clay requiring engineered slabs",
      "Check proximity to established amenities vs future plans",
      "Peak hour traffic on Port Wakefield Road can be heavy",
      "Research specific estate covenants before committing",
      "Some outer areas have limited public transport"
    ],
    
    priceGuide: {
      land: "$150,000 - $280,000",
      build: "$280,000 - $450,000",
      total: "$430,000 - $730,000"
    },
    
    suburbLinks: [
      { name: "Gawler", slug: "gawler" },
      { name: "Angle Vale", slug: "angle-vale" },
      { name: "Two Wells", slug: "two-wells" },
      { name: "Munno Para", slug: "munno-para" },
      { name: "Elizabeth", slug: "elizabeth" },
      { name: "Salisbury", slug: "salisbury" }
    ]
  },
  
  "southern-adelaide": {
    slug: "southern-adelaide",
    name: "Southern Adelaide",
    metaTitle: "Home Builders Southern Adelaide | Local Builders | BuildPilot",
    metaDescription: "Find trusted home builders in Southern Adelaide. Covering Morphett Vale, Seaford, Aldinga, Noarlunga, Hackham, Reynella and coastal suburbs.",
    heroTitle: "Home Builders in Southern Adelaide",
    heroSubtitle: "Local builders who know the south",
    intro: "Southern Adelaide offers beach lifestyle, wine country proximity, and established communities. From affordable Hackham to coastal Seaford, builders who know the south understand the unique opportunities and site conditions.",
    
    coverage: [
      "Morphett Vale & Reynella",
      "Seaford & Seaford Heights",
      "Aldinga Beach & Aldinga",
      "Noarlunga & Noarlunga Downs",
      "Hackham & Hackham West",
      "Aberfoyle Park & Happy Valley",
      "Hallett Cove",
      "Christies Beach",
      "McLaren Vale",
      "Port Noarlunga & Moana"
    ],
    
    popularEstates: [
      { name: "Seaford Heights", location: "Seaford", link: "/estates/seaford-heights" },
      { name: "Hackham South East", location: "Hackham", link: "/estates/hackham-south-east" },
      { name: "Aldinga Beach", location: "Aldinga", link: "/estates/aldinga-beach-estate" }
    ],
    
    whyBuildHere: [
      "Beach lifestyle within 30-50 minutes of the CBD",
      "McLaren Vale wine region on your doorstep",
      "Southern Expressway provides quick city access",
      "Mix of affordable and premium coastal options",
      "Established shopping and services at Colonnades",
      "Growing health and education infrastructure"
    ],
    
    considerations: [
      "Coastal blocks may have specific building requirements",
      "Some elevated areas have sloping blocks with higher site costs",
      "Sandy soils common near coast. Generally good for building",
      "Further south means longer commute to city",
      "Check bushfire ratings in hills-fringe areas"
    ],
    
    priceGuide: {
      land: "$180,000 - $350,000",
      build: "$300,000 - $500,000",
      total: "$480,000 - $850,000"
    },
    
    suburbLinks: [
      { name: "Seaford", slug: "seaford" },
      { name: "Aldinga", slug: "aldinga" },
      { name: "Morphett Vale", slug: "morphett-vale" },
      { name: "Hackham", slug: "hackham" },
      { name: "Reynella", slug: "reynella" },
      { name: "Hallett Cove", slug: "hallett-cove" }
    ]
  },
  
  "adelaide-hills": {
    slug: "adelaide-hills",
    name: "Adelaide Hills",
    metaTitle: "Home Builders Adelaide Hills | Hills Specialists | BuildPilot",
    metaDescription: "Find experienced home builders in Adelaide Hills. Covering Mount Barker, Stirling, Bridgewater, Hahndorf, and surrounding hills communities.",
    heroTitle: "Home Builders in Adelaide Hills",
    heroSubtitle: "Specialists in hills and rural construction",
    intro: "Building in the Adelaide Hills requires specialist knowledge. Sloping sites, bushfire requirements, and rural services make it different from suburban building. Find builders who understand hills construction.",
    
    coverage: [
      "Mount Barker & Littlehampton",
      "Stirling & Aldgate",
      "Bridgewater & Crafers",
      "Hahndorf",
      "Nairne & Woodside",
      "Lobethal",
      "Oakbank & Balhannah",
      "Echunga",
      "Macclesfield",
      "Strathalbyn"
    ],
    
    popularEstates: [
      { name: "Glenlea", location: "Mount Barker", link: "/estates/glenlea" },
      { name: "Aston Hills", location: "Mount Barker", link: "/estates/aston-hills" },
      { name: "Mount Barker Central", location: "Mount Barker", link: "/estates/mt-barker-central" }
    ],
    
    whyBuildHere: [
      "Genuine hills lifestyle with cooler climate",
      "Beautiful natural surroundings and wildlife",
      "Strong sense of community in hills townships",
      "Mount Barker offers metropolitan amenities",
      "Quick freeway access to Adelaide CBD",
      "Wine regions and tourism on your doorstep"
    ],
    
    considerations: [
      "Sloping blocks are common. Budget for significant site costs",
      "Bushfire Attack Level (BAL) ratings affect construction requirements",
      "Some areas require septic systems or rainwater tanks",
      "Cooler climate means higher heating costs",
      "Freeway can be congested at peak times",
      "Check specific block orientation and fall before purchasing"
    ],
    
    priceGuide: {
      land: "$200,000 - $400,000",
      build: "$350,000 - $600,000",
      total: "$550,000 - $1,000,000+"
    },
    
    suburbLinks: [
      { name: "Mount Barker", slug: "mount-barker" },
      { name: "Stirling", slug: "stirling" },
      { name: "Bridgewater", slug: "bridgewater" }
    ]
  },
  
  "western-adelaide": {
    slug: "western-adelaide",
    name: "Western Adelaide",
    metaTitle: "Home Builders Western Adelaide | Coastal Builders | BuildPilot",
    metaDescription: "Find home builders in Western Adelaide. Covering Glenelg, Henley Beach, Grange, West Lakes, Semaphore and beach suburbs.",
    heroTitle: "Home Builders in Western Adelaide",
    heroSubtitle: "Coastal and western suburbs specialists",
    intro: "Western Adelaide offers premium beach lifestyle close to the city. From iconic Glenelg to family-friendly West Lakes, builders in the west understand coastal requirements and established area considerations.",
    
    coverage: [
      "Glenelg & Glenelg South",
      "Henley Beach & Henley Beach South",
      "Grange",
      "West Lakes & West Lakes Shore",
      "Semaphore & Semaphore Park",
      "Tennyson & Grange",
      "Findon & Kidman Park",
      "Lockleys & Underdale",
      "Fulham & Fulham Gardens",
      "Seaton & Royal Park"
    ],
    
    popularEstates: [],
    
    whyBuildHere: [
      "Premium beach lifestyle close to the CBD",
      "Glenelg tram provides car-free city access",
      "Established cafes, restaurants and entertainment",
      "Strong capital growth in beach suburbs",
      "Mix of character areas and modern developments",
      "Family-friendly with good schools"
    ],
    
    considerations: [
      "Premium land prices in beach suburbs",
      "Many areas have heritage or character requirements",
      "Knockdown rebuild is main option in established areas",
      "Coastal building requirements may apply",
      "Smaller blocks common near beach",
      "High demand means competitive market"
    ],
    
    priceGuide: {
      land: "$500,000 - $1,500,000+",
      build: "$400,000 - $800,000+",
      total: "$900,000 - $2,300,000+"
    },
    
    suburbLinks: [
      { name: "Glenelg", slug: "glenelg" },
      { name: "Henley Beach", slug: "henley-beach" },
      { name: "Grange", slug: "grange" },
      { name: "West Lakes", slug: "west-lakes" },
      { name: "Findon", slug: "findon" }
    ]
  }
};

export const getRegionalData = (slug) => regionalData[slug] || null;
export const getAllRegions = () => Object.values(regionalData);
export const getRegionSlugs = () => Object.keys(regionalData);
